module.exports = __webpack_public_path__ + "static/media/instagram.bd965c81.svg";